import { render, staticRenderFns } from "./UpdateCommentModal.vue?vue&type=template&id=1d83bd36&"
import script from "./UpdateCommentModal.vue?vue&type=script&lang=js&"
export * from "./UpdateCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports